<template>
  <Popup v-model="show" overlay-class="billing-apply-popop" position="bottom">
    <div class="billing-apply-pop">
      <div class="pop-header">
        <div class="pop-title">
          <slot name="title"></slot>
          <span class="pop-close" @click="closePop">
            <Icon name="cross" />
          </span>
        </div>
        <slot name="tips"></slot>
      </div>
      <slot
        name="content"
        :list="list"
        :headerType="headerType"
        :sliceNumber="sliceNumber"
        :showEnterpriseMore="showEnterpriseMore"
      ></slot>
    </div>
    <div class="footer">
      <slot name="footer" :handleClickSubmit="handleClickSubmit"></slot>
    </div>
  </Popup>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from 'vue-property-decorator';
import BillingSystemMixins from '../../../mixin/mixins';
import ShowMore from '../../../common/ShowMore.vue';
import Popup from 'vant/lib/popup';
import Icon from 'vant/lib/icon';
import Button from '../../../common/Button.vue';
import 'vant/lib/popup/style';
import 'vant/lib/icon/style';

import {
  fieldObject,
  showTypeSize,
  personListArr,
  headerTypeObject,
  enterPriseListArr,
} from '../../../billingSystem';

@Component({
  components: {
    Icon,
    Popup,
    Button,
    ShowMore,
  },
})
export default class ApplyConfirm extends Mixins(BillingSystemMixins) {
  @Prop({
    type: Boolean,
    default: false,
  })
  value!: boolean;

  @Prop({
    type: String,
    default: '1',
  })
  headerType!: string;

  @Prop({})
  displayField!: any;

  sliceNumber: number = showTypeSize.some;
  personListArr: string[] = personListArr;
  enterPriseListArr: string[] = enterPriseListArr;
  get show() {
    return this.value;
  }
  set show(value: boolean) {
    if (!value) {
      this.$emit('input', false);
    }
  }

  get list() {
    if (!this.displayField) return [];
    this.sliceNumber = showTypeSize.some;
    const needTransferdata =
      this.headerType === headerTypeObject.personal
        ? personListArr
        : enterPriseListArr;
    return needTransferdata.map((item: string) => {
      if (item === 'invoice_amount') {
        return {
          fileldText: fieldObject[item],
          field: item,
          value: `¥${this.transformMoney(this.displayField[item])}`,
        };
      }
      return {
        fileldText: fieldObject[item],
        field: item,
        value: this.displayField[item],
      };
    });
  }

  showEnterpriseMore() {
    this.sliceNumber === showTypeSize.some
      ? (this.sliceNumber = showTypeSize.all)
      : (this.sliceNumber = showTypeSize.some);
  }

  handleClickSubmit() {
    this.$emit('comfirmApply');
  }

  closePop() {
    this.show = false;
  }
}
</script>

<style lang="scss">
@import '../../../style/index.scss';
.billing-apply-popop + .van-popup {
  border-radius: 24px 24px 0px 0px;
}
.pop-close {
  float: right;
  font-size: 36px;
  .van-icon {
    color: #6e688d;
    vertical-align: inherit;
  }
}
.billing-apply-pop {
  padding: 32px 32px 0;
  font-size: 32px;
  .pop-header,
  .pop-tips {
    text-align: center;
  }
  .pop-header {
    color: $_base_color;
    font-weight: 500;
    font-family: $_med_famliy;
    border-bottom: 1px solid $_reset_gray;
    .pop-title {
      margin-bottom: $_base_bottom;
    }
  }
  .pop-tips {
    padding-bottom: $_base_bottom;
    color: #6e688d;
    font-size: 24px;
    font-family: $_reg_famliy;
  }
}
.footer {
  @include flex_layout(center, center);
  padding: 0 0 24px;
}
</style>